import {
  encodeFCompositionId,
  FArrangementTypesEnum,
  FCompositionTypesEnum,
  FEnsembleTypesEnum,
} from '@spazious/dollhouse-shallow-graph';

/**
 * Unique setup type ids.
 */
export enum SchemaTypesEnum {
  FEnsembleDesktop = encodeFCompositionId(
    FCompositionTypesEnum.FEnsemble,
    FEnsembleTypesEnum.Desktop
  ),
  FEnsembleRound = encodeFCompositionId(FCompositionTypesEnum.FEnsemble, FEnsembleTypesEnum.Round),
  FEnsembleCabaret = encodeFCompositionId(
    FCompositionTypesEnum.FEnsemble,
    FEnsembleTypesEnum.Cabaret
  ),
  FEnsembleBoardroom = encodeFCompositionId(
    FCompositionTypesEnum.FEnsemble,
    FEnsembleTypesEnum.Boardroom
  ),
  FArrangementTheater = encodeFCompositionId(
    FCompositionTypesEnum.FArrangement,
    FArrangementTypesEnum.Theater
  ),
  FArrangementRound = encodeFCompositionId(
    FCompositionTypesEnum.FArrangement,
    FArrangementTypesEnum.Round
  ),
  FArrangementClassroom = encodeFCompositionId(
    FCompositionTypesEnum.FArrangement,
    FArrangementTypesEnum.Classroom
  ),
  FArrangementCabaret = encodeFCompositionId(
    FCompositionTypesEnum.FArrangement,
    FArrangementTypesEnum.Cabaret
  ),
  FArrangementCocktail = encodeFCompositionId(
    FCompositionTypesEnum.FArrangement,
    FArrangementTypesEnum.Cocktail
  ),
  FArrangementBoardroom = encodeFCompositionId(
    FCompositionTypesEnum.FArrangement,
    FArrangementTypesEnum.Boardroom
  ),
  FArrangementUshape = encodeFCompositionId(
    FCompositionTypesEnum.FArrangement,
    FArrangementTypesEnum.Ushape
  ),
}
